import { DashboardLayout, DashboardSection, DashboardWidgetOption } from '@/modules/dashboardModule/dashboard-view.model'
import { CASE_DELAYED_SCOPE } from '@/api/resources/dashboard/dashboardService'

export const dashboardLayout =
    (): DashboardLayout[] => [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 2,
            i: '0',
            section: DashboardSection.CLINICAL,
            type: 'info-widget',
            color: 'bg-dark',
            icon: 'fal fa-envelope-open-text',
            label: 'dashboard.widget.unreadRequests',
            hidden: true,
            disabled: false,
            widgetLink: 'clinicalGrid',
            widgetOption: DashboardWidgetOption.REQUESTS_WITH_AP_REPORT_NOT_SEEN
        },
        {
            x: 2,
            y: 0,
            w: 2,
            h: 2,
            i: '1',
            section: DashboardSection.CLINICAL,
            type: 'info-widget',
            color: 'bg-red',
            icon: 'fal fa-file-times',
            label: 'dashboard.widget.blockedRequests',
            hidden: true,
            disabled: false,
            widgetLink: 'clinicalGrid',
            widgetOption: DashboardWidgetOption.LOCKED_REQUESTS
        },
        {
            x: 6,
            y: 0,
            w: 2,
            h: 2,
            i: '2',
            section: DashboardSection.REQUEST,
            type: 'info-widget',
            color: 'bg-green',
            icon: 'fal fa-hourglass-start',
            label: 'dashboard.widget.pendingRequests',
            hidden: true,
            disabled: false,
            widgetLink: 'requestGrid',
            widgetOption: DashboardWidgetOption.REGISTRY_REQUESTED
        },
        {
            x: 8,
            y: 0,
            w: 2,
            h: 2,
            i: '3',
            section: DashboardSection.REQUEST,
            type: 'info-widget',
            color: 'bg-yellow',
            icon: 'fal fa-file-times',
            label: 'dashboard.widget.blockedRequests',
            hidden: true,
            disabled: false,
            widgetLink: 'requestGrid',
            widgetOption: DashboardWidgetOption.REGISTRY_REQUESTS_LOCKED
        },
        {
            x: 10,
            y: 0,
            w: 2,
            h: 2,
            i: '4',
            section: DashboardSection.REGISTRY,
            type: 'info-widget',
            color: 'bg-dark',
            icon: 'fal fa-calendar-day',
            label: 'dashboard.widget.registeredToday',
            hidden: true,
            disabled: false,
            widgetLink: 'caseGrid',
            widgetOption: DashboardWidgetOption.REGISTRY_TODAY
        },
        {
            x: 2,
            y: 1,
            w: 2,
            h: 2,
            i: '5',
            section: DashboardSection.GROSSING,
            type: 'info-widget',
            color: 'bg-green',
            icon: 'icon-scalpel-menu',
            label: 'dashboard.widget.pendingGrossing',
            hidden: true,
            disabled: false,
            widgetLink: 'grossingGrid',
            widgetOption: DashboardWidgetOption.FOR_GROSSING
        },
        {
            x: 4,
            y: 1,
            w: 2,
            h: 2,
            i: '6',
            section: DashboardSection.GROSSING,
            type: 'info-widget',
            color: 'bg-dark',
            icon: 'icon-scalpel-reload',
            label: 'dashboard.widget.pendingRegrossing',
            hidden: true,
            disabled: false,
            widgetLink: 'grossingGrid',
            widgetOption: DashboardWidgetOption.FOR_REGROSSING
        },
        {
            x: 6,
            y: 1,
            w: 2,
            h: 2,
            i: '7',
            section: DashboardSection.GROSSING,
            type: 'info-widget',
            color: 'bg-purple',
            icon: 'fal fa-calendar-day',
            label: 'dashboard.widget.grossingToday',
            hidden: true,
            disabled: false,
            widgetLink: 'grossingGrid',
            widgetOption: DashboardWidgetOption.GROSSING_TODAY
        },
        {
            x: 2,
            y: 4,
            w: 2,
            h: 2,
            i: '8',
            section: DashboardSection.WASTE,
            type: 'info-widget',
            color: 'bg-green',
            icon: 'fal fa-trash',
            label: 'dashboard.widget.pendingWaste',
            hidden: true,
            disabled: false,
            widgetLink: 'wasteGrid',
            widgetOption: DashboardWidgetOption.PENDING_DISPOSAL
        },
        {
            x: 4,
            y: 4,
            w: 2,
            h: 2,
            i: '9',
            section: DashboardSection.WASTE,
            type: 'info-widget',
            color: 'bg-yellow',
            icon: 'fal fa-calendar-day',
            label: 'dashboard.widget.wasteToday',
            hidden: true,
            disabled: false,
            widgetLink: 'wasteGrid',
            widgetOption: DashboardWidgetOption.WASTE_TODAY
        },
        {
            x: 0,
            y: 4,
            w: 2,
            h: 2,
            i: '10',
            section: DashboardSection.INCIDENTS,
            type: 'info-widget',
            color: 'bg-red',
            icon: 'fal fa-exclamation-triangle',
            label: 'dashboard.widget.openIncidents',
            hidden: true,
            disabled: false,
            widgetLink: 'incidentsModule',
            widgetOption: DashboardWidgetOption.OPENED_INCIDENTS
        },
        {
            x: 0,
            y: 1,
            w: 2,
            h: 2,
            i: '11',
            section: DashboardSection.REGISTRY,
            type: 'scan-widget',
            icon: 'fal fa-chart-network',
            label: 'dashboard.widget.newCase',
            hidden: true,
            disabled: false,
            subType: 'case',
            widgetLink: 'newCase'
        },
        {
            x: 4,
            y: 0,
            w: 2,
            h: 2,
            i: '12',
            section: DashboardSection.CLINICAL,
            type: 'scan-widget',
            icon: 'fal fa-file-medical',
            label: 'dashboard.widget.newRequest',
            hidden: true,
            disabled: false,
            subType: 'request',
            widgetLink: 'newCase'
        },
        {
            x: 6,
            y: 4,
            w: 2,
            h: 2,
            i: '13',
            section: DashboardSection.OTHERS,
            type: 'link-widget',
            icon: 'fal fa-users',
            label: 'dashboard.widget.patients',
            hidden: true,
            disabled: false
        },
        {
            x: 2,
            y: 4,
            w: 2,
            h: 2,
            i: '17',
            section: DashboardSection.LABORATORY,
            type: 'info-widget',
            color: 'bg-green',
            icon: 'icon-block',
            label: 'dashboard.widget.pendingConfection',
            hidden: true,
            disabled: false,
            widgetLink: 'laboratoryModule',
            widgetOption: DashboardWidgetOption.PORTION_MAKE
        },
        {
            x: 4,
            y: 4,
            w: 2,
            h: 2,
            i: '18',
            section: DashboardSection.LABORATORY,
            type: 'info-widget',
            color: 'bg-yellow',
            icon: 'fal fa-scalpel-path',
            label: 'dashboard.widget.pendingCut',
            hidden: true,
            disabled: false,
            widgetLink: 'laboratoryModule',
            widgetOption: DashboardWidgetOption.PORTION_CUT
        },
        {
            x: 0,
            y: 4,
            w: 2,
            h: 2,
            i: '19',
            section: DashboardSection.LABORATORY,
            type: 'info-widget',
            color: 'bg-red',
            icon: 'fal fa-barcode-alt',
            label: 'dashboard.widget.pendingScan',
            hidden: true,
            disabled: false,
            widgetLink: 'laboratoryModule',
            widgetOption: DashboardWidgetOption.SUBPORTION_TO_SCANNER
        },
        {
            x: 0,
            y: 0,
            w: 3,
            h: 8,
            i: '14',
            section: DashboardSection.DIAGNOSIS,
            type: 'chart-widget',
            subType: 'casePriority',
            icon: 'far fa-flag',
            prelabel: 'dashboard.widget.pendingCases',
            label: 'dashboard.widget.byPriority',
            hidden: true,
            disabled: false,
            widgetLink: 'diagnosis'
        },
        {
            x: 3,
            y: 0,
            w: 3,
            h: 8,
            i: '15',
            section: DashboardSection.DIAGNOSIS,
            type: 'chart-widget',
            subType: 'caseType',
            icon: 'far fa-chart-network',
            prelabel: 'dashboard.widget.pendingCases',
            label: 'dashboard.widget.byCaseType',
            hidden: true,
            disabled: false,
            widgetLink: 'diagnosis'
        },
        {
            x: 6,
            y: 0,
            w: 3,
            h: 8,
            i: '16',
            section: DashboardSection.DIAGNOSIS,
            type: 'chart-widget',
            subType: 'caseSituation',
            icon: 'far fa-tags',
            prelabel: 'dashboard.widget.pendingCases',
            label: 'dashboard.widget.byCaseSituation',
            hidden: true,
            disabled: false,
            widgetLink: 'diagnosis'
        },
        {
            x: 9,
            y: 0,
            w: 3,
            h: 8,
            i: '20',
            section: DashboardSection.REGISTRY,
            type: 'print-widget',
            icon: 'fal fa-ticket-alt',
            label: 'component.printLabelsModal.printLabels',
            hidden: true,
            disabled: false
        },
        {
            x: 9,
            y: 0,
            w: 3,
            h: 8,
            i: '21',
            section: DashboardSection.DIAGNOSIS,
            type: 'chart-widget',
            subType: 'caseDelayed',
            scope: CASE_DELAYED_SCOPE.GLOBAL,
            icon: 'far fa-hourglass-start',
            prelabel: 'dashboard.widget.delays',
            label: 'dashboard.widget.globalDelay',
            hidden: true,
            disabled: false,
            widgetLink: 'diagnosis',
            uicomponent: 'uicomponent.dashboard.diagnosis.global-delayed-cases'
        },
        {
            x: 9,
            y: 0,
            w: 3,
            h: 8,
            i: '22',
            section: DashboardSection.DIAGNOSIS,
            type: 'chart-widget',
            subType: 'caseDelayed',
            scope: CASE_DELAYED_SCOPE.DIAGNOSIS,
            icon: 'far fa-hourglass-half',
            prelabel: 'dashboard.widget.delays',
            label: 'dashboard.widget.diagnosticDelay',
            hidden: true,
            disabled: false,
            widgetLink: 'diagnosis',
            uicomponent: 'uicomponent.dashboard.diagnosis.delayed-cases'
        }
    ]
